export default {
  namespaced: true,
  state: {
    connectionError: false
  },
  mutations: {
    setConnectionError (state, data) {
      state.connectionError = data
    }
  }
}
